module.exports = __webpack_public_path__ + "static/media/layer2.a814b785.png";